import Filters from "../filters";

export default function Hero() {
  return (
    <section className="bg-gradient-to-l from-teal-700 to-gray-800 py-20 relative">
      <div className="container mini-container relative">
        <div>
          <h1 className="text-theme-white-900 text-2xl lg:text-4xl font-bold text-center">
            ক্যারিয়ার গড়ুন আমাদের সাথে
          </h1>
          <p className="mt-3 text-center text-theme-white-900 text-sm lg:text-base font-medium ">
            কারিগরি, আইটি, হসপিটালিটি, হেলথকেয়ার সহ শতাধিক কোর্স থেকে নিজের
            পছন্দের ট্রেনিং নিন
          </p>
        </div>
        <Filters />
      </div>
    </section>
  );
}
